import { FONT, FontStyleSheet } from '../font-style-sheets';
import { ShelfTalkerMenu } from './shelf-talker-menu';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';

export class FireAndFlowerShelfTalkerMenu extends ShelfTalkerMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.FuturaPt.Regular_400, FONT.FuturaPt.Medium_500];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/tof6ywr.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  override variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }
}
